import { c as _c } from "react/compiler-runtime";
import type { AgentReleaseContext } from '@onefootprint/request-types/dashboard';
import { Dialog, Form, Tag } from '@onefootprint/ui';
import { useEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
type Bump = 'major' | 'minor' | 'patch';
type FormData = {
  bump: Bump;
  notes: string;
};
type Props = {
  open: boolean;
  onClose: () => void;
  release: AgentReleaseContext;
  onSubmit: (data: {
    versionTag: string;
    publishNotes: string;
  }) => Promise<void> | void;
  isSubmitting: boolean;
};
const FORM_ID = 'publish-release-form';
const PublishReleaseDialog = t0 => {
  const $ = _c(86);
  const {
    open,
    onClose,
    release,
    onSubmit,
    isSubmitting
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.header.publishDialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      defaultValues: {
        bump: "patch",
        notes: ""
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const form = useForm(t2);
  let t3;
  if ($[2] !== form.control) {
    t3 = {
      control: form.control,
      name: "bump"
    };
    $[2] = form.control;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const bump = useWatch(t3);
  const nextVersion = release[bumpToFieldName(bump)];
  let t4;
  let t5;
  if ($[4] !== form || $[5] !== open) {
    t4 = () => {
      if (open) {
        form.reset({
          bump: "patch",
          notes: ""
        });
      }
    };
    t5 = [open, form];
    $[4] = form;
    $[5] = open;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== onSubmit || $[9] !== release) {
    t6 = async t7 => {
      const {
        bump: bump_0,
        notes
      } = t7;
      await onSubmit({
        versionTag: release[bumpToFieldName(bump_0)],
        publishNotes: notes
      });
    };
    $[8] = onSubmit;
    $[9] = release;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleSubmit = t6;
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp2);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isSubmitting || $[16] !== t8) {
    t9 = {
      form: FORM_ID,
      label: t8,
      type: "submit",
      loading: isSubmitting
    };
    $[15] = isSubmitting;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t(_temp3);
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isSubmitting || $[21] !== onClose || $[22] !== t10) {
    t11 = {
      label: t10,
      onClick: onClose,
      disabled: isSubmitting
    };
    $[20] = isSubmitting;
    $[21] = onClose;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== form || $[25] !== handleSubmit) {
    t12 = form.handleSubmit(handleSubmit);
    $[24] = form;
    $[25] = handleSubmit;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t(_temp4);
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13) {
    t14 = <p className="text-label-2 text-primary w-[110px]">{t13}</p>;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== release.latestVersion) {
    t15 = <Tag>v{release.latestVersion}</Tag>;
    $[31] = release.latestVersion;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15) {
    t16 = <div className="flex items-center"><div className="w-full md:w-1/2 flex items-center gap-2">{t14}{t15}</div></div>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t(_temp5);
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17) {
    t18 = <p className="text-label-2 text-primary w-[110px]">{t17}</p>;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== nextVersion) {
    t19 = <Tag>v{nextVersion}</Tag>;
    $[40] = nextVersion;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t18 || $[43] !== t19) {
    t20 = <div className="w-full md:w-1/2 flex items-center gap-2">{t18}{t19}</div>;
    $[42] = t18;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t) {
    t21 = t(_temp6);
    $[45] = t;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t21) {
    t22 = {
      value: "major",
      label: t21
    };
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t(_temp7);
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t23) {
    t24 = {
      value: "minor",
      label: t23
    };
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t) {
    t25 = t(_temp8);
    $[53] = t;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t25) {
    t26 = {
      value: "patch",
      label: t25
    };
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t22 || $[58] !== t24 || $[59] !== t26) {
    t27 = <fieldset className="w-full md:w-1/2"><Form.RadioGroup name="bump" options={[t22, t24, t26]} className="grid grid-cols-3 gap-2" /></fieldset>;
    $[57] = t22;
    $[58] = t24;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t20 || $[62] !== t27) {
    t28 = <div className="flex flex-col items-start gap-3 md:flex-row md:items-center md:gap-0">{t20}{t27}</div>;
    $[61] = t20;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t) {
    t29 = t(_temp9);
    $[64] = t;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t) {
    t30 = t(_temp10);
    $[66] = t;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t29 || $[69] !== t30) {
    t31 = <Form.Textarea size="compact" name="notes" label={t29} placeholder={t30} />;
    $[68] = t29;
    $[69] = t30;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t12 || $[72] !== t16 || $[73] !== t28 || $[74] !== t31) {
    t32 = <form id={FORM_ID} className="flex flex-col gap-4" onSubmit={t12}>{t16}{t28}{t31}</form>;
    $[71] = t12;
    $[72] = t16;
    $[73] = t28;
    $[74] = t31;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  let t33;
  if ($[76] !== form || $[77] !== t32) {
    t33 = <FormProvider {...form}>{t32}</FormProvider>;
    $[76] = form;
    $[77] = t32;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== onClose || $[80] !== open || $[81] !== t11 || $[82] !== t33 || $[83] !== t7 || $[84] !== t9) {
    t34 = <Dialog title={t7} open={open} onClose={onClose} primaryButton={t9} secondaryButton={t11}>{t33}</Dialog>;
    $[79] = onClose;
    $[80] = open;
    $[81] = t11;
    $[82] = t33;
    $[83] = t7;
    $[84] = t9;
    $[85] = t34;
  } else {
    t34 = $[85];
  }
  return t34;
};
const bumpToFieldName = (bump: Bump): 'nextMajor' | 'nextMinor' | 'nextPatch' => {
  if (bump === 'major') return 'nextMajor';
  if (bump === 'minor') return 'nextMinor';
  return 'nextPatch';
};
export default PublishReleaseDialog;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.publish;
}
function _temp3($_1) {
  return $_1.cancel;
}
function _temp4($_2) {
  return $_2.version.current;
}
function _temp5($_3) {
  return $_3.version.next;
}
function _temp6($_4) {
  return $_4.bump.major;
}
function _temp7($_5) {
  return $_5.bump.minor;
}
function _temp8($_6) {
  return $_6.bump.patch;
}
function _temp9($_7) {
  return $_7.notes.label;
}
function _temp10($_8) {
  return $_8.notes.placeholder;
}